<template>
    <fade-loader v-bind="fadeLoader">
        <v-container fluid>
            <v-layout row wrap>
                <div class="content-wrap">
                    <v-flex xs12 v-for="layer in getValidLayers" :key="layer.id">
                        <h1>
                            <label>
                                <i></i>
                                <span>
                                    <simple-svg
                                            :filepath="layer.iconUrl"
                                            :fill="layer.color"
                                            :stroke="layer.stroke"
                                    ></simple-svg>
                                    <div class="layer-title">{{ layer.title}}</div>
                                </span>
                            </label>
                        </h1>
                        <dynamic-table v-if="tableOptions[layer.id]"
                                       :options="tableOptions[layer.id]"
                                       :filter="searchParams"
                                       :api-call="apiCall(layer.id)"
                                       :export-loading="loadingExport"
                                       @export="exportData($event, layer.id)"
                                       @click="openToolbox"
                                       :active-item="activeItem"></dynamic-table>
                    </v-flex>
                </div>
            </v-layout>
        </v-container>
    </fade-loader>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import DynamicTable from '@/components/DynamicTable'
  import GeoObjectAPI from '@/api/geoObject'
  import LayerAPI from '@/api/layer'
  import GeoObject from '@/models/GeoObject'

  export default {
    components: { DynamicTable },
    props: {
      layers: {
        type: Array
      }
    },
    data () {
      return {
        loadingExport: false,
        tableOptions: {},
        activeItem: null
      }
    },
    mounted () {
      let promises = []
      for (let i = 0; i < this.layers.length; i++) {
        if (this.layers[i].type !== 'wms') {
          promises.push(this.loadLayer(this.layers[i].id))
        }
      }
      this.$resolve(promises)
    },
    methods: {
      async exportData ({ type, headers }, layerId) {
        if (this.loadingExport === true) {
          this.$alert.error('Ein weiterer Export läuft bereits')
          return false
        }
        this.loadingExport = true
        this.$alert.success('Der Export wird erstellt, dies kann unter umständen etwas dauern')
        GeoObjectAPI.export(layerId, { type, headlines: headers }, { searchParams: this.$store.getters['search/getSearches'] })
          .then(response => {
            if (response.url) {
              this.downloadExport(response.url)
            }
          })
          .catch(err => {
            if (typeof err.response !== 'undefined' && typeof err.response.data !== 'undefined' && typeof err.response.data.url !== 'undefined') {
              const url = err.response.data.url
              this.downloadExport(url)
            } else {
              this.$alert.error('Ein unerwarteter Fehler ist aufgetreten')
            }
          })
          .finally(() => {
            this.loadingExport = false
          })
      },
      downloadExport (url) {
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        const app = document.getElementById('app')
        app.parentNode.insertBefore(iframe, app)
        iframe.setAttribute('src', url)
      },
      async loadLayer (layerId) {
        let response = await LayerAPI.getColumns(layerId)

        Vue.set(this.tableOptions, layerId, {
          headers: response.data
        })
        return response
      },
      openToolbox (item) {
        this.activeItem = item
        this.$store.dispatch('geoview/addActiveObject', { id: item.id, layer: item.layer })
        this.$toolbox.open({
          item: new GeoObject(item),
          onConfirm: (toolbox) => {
            // hier die daten zum server senden
            // toolbox.contentData gibt das item zurück (GeoObjectCollection)
            return GeoObjectAPI.udpate(toolbox.contentData.id, toolbox.contentData)
          },
          onConfirmError: (toolbox, error) => {
            // hier den fehler in die toolbox setzen
            toolbox.errorData = error.response.data.error
          }
        }).then((result) => {
          this.$store.dispatch('geoview/removeActiveObject', { id: item.id })
          if (typeof result.content === 'object' && result.content) {
            if (typeof result.content.isDeleted !== 'undefined' && result.content.isDeleted) {
              this.$alert.success('Erfolgreich gelöscht')
              this.map.updateLayerSources(this.filterConfig)
            }
          }
          if (result.confirmed) {
            this.$alert.success('Erfolgreich gespeichert')
          }
          if (this.activeItem === item) {
            this.activeItem = null
          }
        })
      },
      apiCall (layerId) {
        return (page, rowsPerPage, searchParams, sorting, options) => {
          return GeoObjectAPI.getList(layerId, page, rowsPerPage, searchParams, sorting, options)
        }
      }
    },
    computed: {
      searchParams () {
        return { searchParams: this.$store.getters['search/getSearches'] }
      },
      getValidLayers () {
        return this.layers.filter((layer) => layer.type !== 'wms')
      }
    },
    watch: {
      layers (newVal, oldVal) {
        const newLayers = _.differenceBy(newVal, oldVal, 'id')
        for (let i = 0; i < newLayers.length; i++) {
          if (newLayers[i].type !== 'wms') {
            this.loadLayer(newLayers[i].id)
          }
        }

        const missingLayer = _.differenceBy(oldVal, newVal, 'id')
        for (let i = 0; i < missingLayer.length; i++) {
          Vue.delete(this.tableOptions, missingLayer[i].id)
        }
      }
    }
  }
</script>

<style scoped>

</style>
